{
  "version": 1,
  "asset_id": "6c2403d7-06a7-4177-9324-6e67de67355a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6c2403d7-06a7-4177-9324-6e67de67355a/checkpoint-charlie.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6c2403d7-06a7-4177-9324-6e67de67355a/checkpoint-charlie.webp",
  "original_filename": "checkpoint-charlie.webp",
  "size": 207344,
  "content_type": "image/webp",
  "created_at": "2026-08-18T01:12:52Z"
}
